export const RESUMEQUEUE_TASK = 'resumeQueue_task';
export const RESUMEQUEUE_TASK_SUCCESSFUL = 'resumeQueue_task_successfull';
export const RESUMEQUEUE_TASK_FAILED = 'resumeQueue_task_failed';



